var _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedulingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "scheduling_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.64,3.27H18.55V1.09H16.37V3.27H7.63V1.09H5.45V3.27H4.36A2.17,2.17,0,0,0,2.19,5.45V20.73a2.18,2.18,0,0,0,2.18,2.18H19.64a2.19,2.19,0,0,0,2.18-2.18V5.45A2.19,2.19,0,0,0,19.64,3.27Zm0,17.46H4.36v-12H19.64Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.5 19.14 6.68 15.32 8.22 13.78 10.5 16.05 16 10.55 17.55 12.09 10.5 19.14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingIcon);
export default __webpack_public_path__ + "static/media/scheduling_icon.39dab4efec1d315a7683eaaede5b5ff4.svg";
export { ForwardRef as ReactComponent };